<template>
  <g>
    <defs>
      <path
        id="close-circle@1x-a"
        d="M12,4 C16.418,4 20,7.582 20,12 C20,16.418 16.418,20 12,20 C7.582,20 4,16.418 4,12 C4,7.582 7.582,4 12,4 Z M12,5.599 C8.465,5.599 5.6,8.465 5.6,12 C5.6,15.534 8.465,18.4 12,18.4 C15.535,18.4 18.4,15.534 18.4,12 C18.4,8.465 15.535,5.599 12,5.599 Z M13.803,8.8297 C14.168,8.4637 14.803,8.4647 15.166,8.8297 C15.542,9.2057 15.542,9.8167 15.166,10.1927 L15.166,10.1927 L13.364,11.9957 L15.166,13.7987 C15.542,14.1747 15.542,14.7857 15.166,15.1617 C14.984,15.3437 14.742,15.4437 14.484,15.4437 C14.227,15.4437 13.984,15.3437 13.803,15.1617 L13.803,15.1617 L12.001,13.3597 L10.2,15.1617 C10.019,15.3437 9.776,15.4437 9.519,15.4437 C9.261,15.4437 9.019,15.3437 8.837,15.1617 C8.654,14.9787 8.554,14.7367 8.554,14.4797 C8.554,14.2227 8.653,13.9797 8.836,13.7977 L8.836,13.7977 L10.637,11.9957 L8.835,10.1927 C8.653,10.0117 8.553,9.7687 8.553,9.5127 C8.554,9.2547 8.654,9.0137 8.836,8.8317 C9.2,8.4667 9.835,8.4667 10.199,8.8297 L10.199,8.8297 L12.001,10.6317 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use :fill="currentColor" :opacity="opacity" xlink:href="#close-circle@1x-a" />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>